import React from "react";

import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import TabList from "@mui/lab/TabList";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import AddIcon from "@mui/icons-material/Add";
import Pending from "@mui/icons-material/Pending";

import { useDispatch, useSelector } from "react-redux";

import SvgIconStyle from "../../../components/SvgIconStyle";

import CreateDonationModel from "../CreateDonationModel";
import { setDashboardTab, setSelectedDonation } from "../slice";

import { dashboardMenu, entityData } from "../../../data";
import { buttonStyles, paperStyles, tabStyles } from "./styles";
import { EntityType, RegistrationStatus } from "../../../common/enum";
import { useNavigate } from "react-router-dom";

export default function SideNavbar({ t }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const dispatch = useDispatch();
  const {
    auth: {
      user: { userId, entityId ,status},
      profile: { entity },
    },
    donationCart: { donationId } = {},
    dashboardInfo: {
      myActiveDonations: { donationDetails },
      entityProfileSelect,
    },
  } = useSelector((state) => state);
  const [open, setOpen] = React.useState(false);

  const handleOpen = React.useCallback(() => setOpen(true), []);

  const pendingDonation = !donationId; //!donationId;

  const navigate = useNavigate();

  const handleTabChange = React.useCallback(
    (event, newValue) => {
      navigate(newValue);
    },
    [dispatch]
  );

  const updatedMenu = React.useMemo(() => {
    if (
      (entity?.entityType === EntityType?.distributor ||
        entity?.entityType === EntityType.specialDistributor ||
        (entity?.entityType === EntityType?.donorDistributor &&
          entityProfileSelect === EntityType.distributor)) &&
      entity?.isParentEntity === true &&
      entity?.isGroupEntity === true
    ) {
      return dashboardMenu;
    } else if (entity?.entityType === EntityType.donor) {
      return dashboardMenu.filter(
        (menu) => !menu.type || menu.type !== EntityType.distributor
      );
    }
    return dashboardMenu;
  }, [dashboardMenu]);

  const menu = React.useMemo(() => {
    if (entity?.isParentEntity === true && entity?.isGroupEntity === true && userId == entityId) {
      return updatedMenu.filter((menu) => menu.title !== "manageManagers");
    } else if (
      ((entity?.isParentEntity === false && entity?.isGroupEntity === true) ||
        entity?.isGroupEntity === false) &&
      userId === entityId
    ) {
      return updatedMenu.filter((menu) => menu.title !== "manageBranches");
    }
    // else if (
    //   ((entity?.isParentEntity === false && entity?.isGroupEntity === true)) &&userId === entityId
    // ) {
    //   return updatedMenu.filter((menu) => menu.title !== "manageBranches");
    // } 
    else if (
      ((entity?.isParentEntity === false && entity?.isGroupEntity === true) ||
       ( entity?.isGroupEntity === false  && userId !== entityId) ||
       ( entity?.isGroupEntity === true  && userId !== entityId && entity?.isParentEntity === true)
      )
    ) {
      return updatedMenu.filter(
        (menu) =>
          menu.title !== "manageBranches" && menu.title !== "manageManagers"
      );
    }
  }, [updatedMenu]);

  return (
    <>
      <Paper elevation={12} sx={paperStyles}>
        <TabList
          aria-label="lab API tabs example"
          onChange={handleTabChange}
          orientation={matches && "vertical"}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          TabIndicatorProps={{
            style: {
              background: "#E1EFB0",
              width: 1,
              justifyContent: "flex-start",
            },
          }}
        >
          {(entity?.entityType === EntityType.donor ||
            entityProfileSelect === EntityType.donor) &&
            ((entity?.isParentEntity === false || entity?.parentEntityId !== null || entity?.isGroupEntity === false) ||
            (entity?.isParentEntity === true && entity?.isGroupEntity === true && userId !== entityId))&& (
              <Button
                sx={{
                  m: 1,
                  [theme.breakpoints.up("md")]: {
                    marginBottom: "20px",
                    // marginX: "20px",
                    borderRadius: "4px",
                  },
                  fontFamily: "Poppins",
                  minWidth: "150px",
                }}
                size="large"
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleOpen}
                fullWidth
                disabled={
                  status === RegistrationStatus.inActive ||
                  status === RegistrationStatus.inAtivo ||
                  status === RegistrationStatus.revoked
                }
              >
                {t("newDonation")}
              </Button>
            )}
          {menu?.map((item, i) => (
            <Tab
              sx={tabStyles}
              icon={
                <SvgIconStyle
                  src={item.icon}
                  sx={{ [theme.breakpoints.up("md")]: { mr: "20px" } }}
                />
              }
              // onClick={handleTabChange(i)}
              label={
                <Typography
                  fontWeight={"600"}
                  fontSize={14}
                  fontFamily={"Poppins"}
                  sx={{ wordBreak: "break-all" }}
                >
                  {t(item.title)}
                </Typography>
              }
              iconPosition={matches ? "start" : "top"}
              value={item.link}
              key={i}
            />
          ))}
        </TabList>
      </Paper>
      <CreateDonationModel open={open} setOpen={setOpen} t={t} />
    </>
  );
}
